import pino from 'pino';
import { logflarePinoVercel } from 'pino-logflare';

// create pino-logflare console stream for serverless functions and send function for browser logs
const {
  stream: logFlareStream,
  send: logFlareSend,
} = logflarePinoVercel({
  apiKey: process.env.NEXT_PUBLIC_LOGFLARE_API_KEY,
  sourceToken: process.env.NEXT_PUBLIC_LOGFLARE_SOURCE_TOKEN,
});

const stream =
  process.env.NODE_ENV === 'production' ? logFlareStream : undefined;

const browser =
  process.env.NODE_ENV === 'production'
    ? {
        write: () => {}, // noop to not write to Browser's console.log in production
        transmit: {
          send: logFlareSend,
        },
      }
    : {};

// create pino loggger
const logger = pino(
  {
    browser,
    level: 'debug',
    base: {
      processes_str: JSON.stringify(process.versions),
      revision: process.env.version,
    },
  },
  stream,
);

export default logger;
